export default __webpack_public_path__ + "adf2b418abbe9a767ac415152c378b60.png";